import { Box, Heading, Text, Flex, Image, SimpleGrid, Stack } from '@chakra-ui/react'
import { useRef, useState, useEffect } from 'react';
import { useInView } from '../../../hooks/useInView';
import imgHome1 from '../../../assets/img/home/home2/FotoswebsiteTMG-01.png';
import imgHome2 from '../../../assets/img/home/home2/FotoswebsiteTMG-02.png';
import imgHome3 from '../../../assets/img/home/home2/FotoswebsiteTMG-03.png';
import imgHome4 from '../../../assets/img/home/home2/FotoswebsiteTMG-04.png';
import imgHome5 from '../../../assets/img/home/home2/FotoswebsiteTMG-05.png';
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../../helpers/fontSizesByLang';
import { useMediaQuery } from '@chakra-ui/react';

function HomeSection2() {

    const sectionRef = useRef();
    const isInView = useInView(sectionRef);
    const [count1, setCount1] = useState(0);
    const [count2, setCount2] = useState(0);
    const [count3, setCount3] = useState(0);
    const { t, i18n } = useTranslation();
    const fontSizes = fontSizesByLang[i18n.language];
    const [isTabletLandscape] = useMediaQuery(
        '(min-width: 1024px) and (max-width: 1279px)'
    );


    useEffect(() => {
        if (isInView) {
            const interval1 = setInterval(() => {
                setCount1((prev) => {
                    if (prev >= 85) {
                        clearInterval(interval1);
                        return prev;
                    }
                    return prev + 1;
                });
            }, 15);

            const interval2 = setInterval(() => {
                setCount2((prev) => {
                    if (prev >= 250) {
                        clearInterval(interval2);
                        return prev;
                    }
                    return prev + 1;
                });
            }, 5);

            const interval3 = setInterval(() => {
                setCount3((prev) => {
                    if (prev >= 3670) {
                        clearInterval(interval3);
                        return prev;
                    }
                    return prev + 10;
                });
            }, 1);

            return () => {
                clearInterval(interval1);
                clearInterval(interval2);
                clearInterval(interval3);
            };
        }
    }, [isInView]);

    return (

        <Flex
            id="about"
            bg={'#1E1D1D'}
            flexDirection="column"
            backgroundRepeat="no-repeat"
            backgroundSize={{ base: 'cover', md: 'cover', lg: 'cover' }}
            backgroundPosition={{ base: 'center', }}
            marginTop="0%"
            minHeight="100vh"
            alignItems={'center'}
        >
            <Heading
                as="h2"
                size={{ base: 'xl', md: '2xl', lg: "3xl" }}
                textAlign="center"
                fontFamily={'Roboto Condensed'}
                fontWeight={'black'}
                marginTop={{ base: '7%', md: '5%' }}
                color={'#FFFFFF'}
                fontSize={fontSizes.tittlefont}
            >
                <Box
                    as="span"
                    color="white"
                    display={{ base: "block", md: "inline" }}
                >
                    {t("whatwe")}

                </Box>
                <Text as="span" color="#ae8245">
                    {t("dobest")}
                </Text>
            </Heading>
            <Text
                margin={'2%'}
                textAlign={{ base: 'left', lg: "center" }}
                color="#929292"
                width={{ base: '90%', md: '80%', lg: '38%' }}
                marginTop="6"
                fontSize={fontSizes.textfont}
                fontFamily={'Inter'}
            >
                {t("homeinfo2")}
            </Text>

            <SimpleGrid columns={{ base: 1, md: 3 }} gap={6}
                mt={'3%'}
                paddingLeft={{ base: '0%', md: '0%' }}
            >

                <Box>
                    <Flex direction="column"
                        w="100%"
                        justifyContent="center"
                        p={{ base: "1%", md: "1%", lg: "1%" }}
                    >
                        <Box
                            boxSize={
                                isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                            }
                            mx="auto"
                            overflow="hidden"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Image
                                src={imgHome1}
                                w={{ base: "90%", md: "90%", lg: "100%" }}
                                h={{ base: "220px", md: "90%", lg: "80%" }}
                                objectFit="cover"
                                objectPosition="center"
                                borderRadius="30px"
                                filter="grayscale(100%)"
                                transition="all 0.4s ease-in-out"
                                _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                            />
                        </Box>

                        <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" fontSize="120%">
                            {t("title-image1")}
                        </Text>

                        <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                            {t("title-info1")}
                        </Text>
                    </Flex>
                </Box>

                <Box>
                    <Flex direction="column" w="100%"
                        justifyContent="center"
                        p={{ base: "1%", md: "1%", lg: "1%" }}
                    >
                        <Box
                            boxSize={
                                isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                            }
                            w="100%"
                            maxW="420px"
                            mx="auto"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="30px"
                        >
                            <Image
                                src={imgHome2}
                                w={{ base: "80%", md: "90%", lg: "100%" }}
                                h={{ base: "220px", md: "90%", lg: "80%" }}
                                objectFit="cover"
                                objectPosition="right"
                                borderRadius="30px"
                                filter="grayscale(100%)"
                                transition="all 0.4s ease-in-out"
                                _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                            />
                        </Box>

                        <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" textAlign="justify" fontSize="120%">
                            {t("title-image2")}
                        </Text>

                        <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                            {t("title-info2")}
                        </Text>
                    </Flex>
                </Box>

                <Box>
                    <Flex direction="column" w="100%"
                        justifyContent="center"
                        p={{ base: "1%", md: "1%", lg: "1%" }}
                    >
                        <Box
                            boxSize={
                                isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                            }
                            w="100%"
                            maxW="420px"
                            mx="auto"
                            overflow="hidden"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="30px"
                        >
                            <Image
                                src={imgHome3}
                                w={{ base: "80%", md: "90%", lg: "100%" }}
                                h={{ base: "220px", md: "90%", lg: "80%" }}
                                borderRadius="30px"
                                filter="grayscale(100%)"
                                transition="all 0.4s ease-in-out"
                                _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                            />
                        </Box>

                        <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" fontSize="120%">
                            {t("title-image3")}
                        </Text>

                        <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                            {t("title-info3")}
                        </Text>
                    </Flex>
                </Box>

                <Box
                    gridColumn={{ base: "auto", md: "1 / span 3" }}
                    w="100%"
                >
                    <Stack
                        direction={{ base: "column", md: "row" }}
                        spacing={{ base: 4, md: '5%' }}
                        justifyContent="center"
                        alignItems="center"
                    >
                        {/* ITEM 4 */}
                        <Box w={{ base: "100%", md: "30%" }}
                            maxW={{ base: "100%", md: "420px" }}
                        >
                            <Flex direction="column"
                                w="100%"
                                justifyContent="center"
                                p={{ base: "1%", md: "7%", lg: "1%" }}

                            >
                                <Box
                                    boxSize={
                                        isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                                    }
                                    w="100%"
                                    maxW="420px"
                                    mx="auto"
                                    overflow="hidden"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Image
                                        src={imgHome4}
                                        w={{ base: "85%", md: "90%", lg: "100%" }}
                                        h={{ base: "220px", md: "90%", lg: "80%" }}
                                        objectFit="cover"
                                        objectPosition="center"
                                        borderRadius="30px"
                                        filter="grayscale(100%)"
                                        transition="all 0.4s ease-in-out"
                                        _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                                    />
                                </Box>

                                <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" w={'100%'} fontSize="120%">
                                    {t("title-image4")}
                                </Text>

                                <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                                    {t("title-info4")}
                                </Text>
                            </Flex>
                        </Box>

                        {/* ITEM 5 */}
                        <Box w={{ base: "100%", md: "30%" }}
                            maxW={{ base: "100%", md: "420px" }}
                        >
                            <Flex direction="column"
                                w="100%"
                                justifyContent="center"
                                p={{ base: "1%", md: "7%", lg: "1%" }}

                            >
                                <Box
                                    boxSize={
                                        isTabletLandscape ? "280px" : { base: "340px", md: "250px", lg: "390px" }
                                    }
                                    w="100%"
                                    maxW="420px"
                                    mx="auto"
                                    overflow="hidden"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Image
                                        src={imgHome5}
                                        w={{ base: "80%", md: "90%", lg: "100%" }}
                                        h={{ base: "220px", md: "90%", lg: "80%" }}
                                        objectFit="cover"
                                        objectPosition="center"
                                        borderRadius="30px"
                                        filter="grayscale(100%)"
                                        transition="all 0.4s ease-in-out"
                                        _hover={{ filter: "grayscale(0%)", transform: "scale(1.03)" }}
                                    />
                                </Box>

                                <Text color="#ae8245" fontFamily="Inter" fontWeight="heavy" fontSize="120%">
                                    {t("title-image5")}
                                </Text>

                                <Text color="#FFFFFF" fontFamily="Inter" fontWeight="light" w="100%">
                                    {t("title-info5")}
                                </Text>
                            </Flex>
                        </Box>
                    </Stack>
                </Box>


            </SimpleGrid>

            <Heading
                as="h2"
                size={{ base: 'xl', md: '2xl', lg: "3xl" }}
                textAlign={{ base: 'left', md: 'center' }}
                fontFamily={'Roboto Condensed'}
                fontWeight={'black'}
                marginTop={{ base: '7%', md: '5%' }}
                color={'#FFFFFF'}
                fontSize={{ base: '200%', md: '300%' }}
            >
                {t("OUR")}{" "}
                <Text as="span" color="#ae8245" >
                    {t("ARCHIEVEMENTS")}
                </Text>
            </Heading>

            <Flex
                justify="center"
                align="center"
                gap={{ base: '30%', md: '10%', lg: '5%' }}
                mt={10}
                direction={{ base: 'column', md: 'column', lg: 'row' }}
                marginBottom={'10%'}
                padding={'2%'}
                ref={sectionRef}
            >
                <Flex direction={'column'}
                    textAlign={'center'}
                    alignItems={'center'}
                >
                    <Box
                        overflow="hidden"
                        height={{ base: "97px", md: "170px", lg: "180px" }}   // recorta más o menos según tamaño
                        display="flex"
                        justifyContent="center"
                        alignItems="flex-start"
                    >

                        <Text fontSize={{ base: "100px", md: "180px", lg: "180px" }}
                            fontWeight="bold"
                            fontFamily="Avenir LT Pro"
                            color="transparent"
                            sx={{
                                WebkitTextStroke: "3px white",
                                paintOrder: "stroke",
                                WebkitTextFillColor: "transparent",
                                WebkitTextStrokeLinecap: "round",
                                WebkitTextStrokeLinejoin: "round",
                            }}
                        >
                            {count2}
                        </Text>
                    </Box>
                    <Text color="#ae8245"
                        fontFamily="Inter"
                        fontWeight="medium"
                        marginTop="5%"
                        fontSize={{ base: "80%", md: "110%", lg: "130%" }}
                    >
                        {t("count1")}
                    </Text>
                </Flex>
                <Flex direction={'column'}
                    textAlign={'center'}
                    alignItems={'center'}
                >
                    <Box
                        overflow="hidden"
                        height={{ base: '97px', md: "170px", lg: "180px" }}   // recorta más o menos según tamaño
                        display="flex"
                        justifyContent="center"
                        alignItems="flex-start"
                    >
                        <Text
                            fontSize={{ base: '100px', md: "180px", lg: "180px" }}
                            fontWeight="bold"
                            fontFamily="Avenir LT Pro"
                            color="transparent"
                            sx={{
                                WebkitTextStroke: "3px white",
                                paintOrder: "stroke",
                                WebkitTextFillColor: "transparent",
                                WebkitTextStrokeLinecap: "round",
                                WebkitTextStrokeLinejoin: "round",
                            }}
                        >
                            {count1}+
                        </Text>
                    </Box>

                    <Text color="#ae8245"
                        fontFamily="Inter"
                        fontWeight="medium"
                        marginTop="5%"
                        fontSize={{ base: "80%", md: "110%", lg: "130%" }}
                    >
                        {t("count2")}
                    </Text>
                </Flex>

                <Flex direction={'column'}
                    textAlign={'center'}
                    alignItems={'center'}
                >
                    <Box
                        overflow="hidden"
                        height={{ base: '97px', md: "170px", lg: "180px" }}   // recorta más o menos según tamaño
                        display="flex"
                        justifyContent="center"
                        alignItems="flex-start"
                    >

                        <Text fontSize={{ base: '100px', md: "180px", lg: "180px" }}
                            fontWeight="bold"
                            fontFamily="Avenir LT Pro"
                            color="transparent"
                            sx={{
                                WebkitTextStroke: "3px white",
                                paintOrder: "stroke",
                                WebkitTextFillColor: "transparent",
                                WebkitTextStrokeLinecap: "round",
                                WebkitTextStrokeLinejoin: "round",
                            }}
                        >
                            {count3}+
                        </Text>
                    </Box>
                    <Text color="#ae8245"
                        fontFamily="Inter"
                        fontWeight="medium"
                        marginTop="5%"
                        fontSize={{ base: "80%", md: "110%", lg: "130%" }}>{t("count3")} </Text>
                </Flex>
            </Flex>
        </Flex>

    )
}

export default HomeSection2
